module.exports = __webpack_public_path__ + "static/9-413a77190eace882b5a9870fdd18e2cf.jpg";